import { useState, useCallback, useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { createApiClient } from '../lib/api-client';

export function useProviders() {
  const { getAccessToken } = useAuth();
  const api = useMemo(() => createApiClient(getAccessToken), [getAccessToken]);
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchProviders = useCallback(async () => {
    setLoading(true);
    try {
      const data = await api.get('/providers');
      setProviders(data.providers || []);
      return data.providers;
    } catch (err) {
      setError(err.message);
      return [];
    } finally {
      setLoading(false);
    }
  }, [api]);

  const addModel = useCallback(async (providerSlug, modelName) => {
    try {
      const data = await api.post(`/providers/${providerSlug}/models`, { model: modelName });
      
      // Update local state to reflect the new model immediately
      setProviders(prev => prev.map(p => {
        if (p.slug === providerSlug) {
          const metadata = p.metadata || {};
          const models = metadata.models || [];
          if (!models.includes(modelName)) {
            return {
              ...p,
              metadata: { ...metadata, models: [...models, modelName] }
            };
          }
        }
        return p;
      }));
      
      return data;
    } catch (err) {
      console.error('Failed to persist model to DB:', err);
      throw err;
    }
  }, [api]);

  return {
    providers,
    loading,
    error,
    fetchProviders,
    addModel
  };
}
